import React from 'react';
import {AdminSection, Items} from 'admin/components';

const drawAdminSection = (data, onChange) => {
  return  <AdminSection title = {data.title}>
            {data.items.map((item,index) => {
              return <Items item = {item} docName = {data.docName} onChange = {onChange} key = {index}/>
            })}
          </AdminSection>
}


export default drawAdminSection;